import axios from "axios";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { motion } from "framer-motion";

const cookie = Cookies.get("jwt");
const token = `${cookie}`;

const HistoryCommission = () => {
  const [dataWithdrawHistory, setDataWithdrawHistory] = useState([]);

  useEffect(() => {
    const fetchDataWithdrawHistory = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/banking/statement-history`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const historyData = response.data.MoneyRecievedHistory;
        setDataWithdrawHistory(historyData.reverse());
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataWithdrawHistory();
  }, []);

  const formatDate = (datetimeString) =>
    new Intl.DateTimeFormat("th-TH", { day: "numeric", month: "short", year: "2-digit" }).format(new Date(datetimeString));

  const formatTime = (datetimeString) =>
    new Intl.DateTimeFormat("th-TH", { hour: "2-digit", minute: "2-digit" }).format(new Date(datetimeString));

  const formatPrice = (price) =>
    new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }).format(price).replace("฿", "").trim();

  if (dataWithdrawHistory === null) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-lg mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="flex items-center gap-3"
        >
          <button
            onClick={() => window.location.replace("/user/point")}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider">คอมมิชชั่น</p>
            <h1 className="text-lg font-bold text-gray-900">ประวัติธุรกรรม</h1>
          </div>
        </motion.div>

        {/* ── History list ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.05, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
        >
          {dataWithdrawHistory.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 gap-3 text-gray-400">
              <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center">
                <img src="https://cdn-icons-png.flaticon.com/512/3503/3503786.png" alt="" className="w-7 h-7 opacity-30" />
              </div>
              <p className="text-sm">ยังไม่มีประวัติธุรกรรม</p>
            </div>
          ) : (
            <>
              <div className="px-5 py-3.5 border-b border-gray-100">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">รายการทั้งหมด</p>
              </div>
              <div className="divide-y divide-gray-50">
                {dataWithdrawHistory.map((data, index) => (
                  <div key={index} className="flex items-center gap-3.5 px-5 py-4">
                    {/* Icon */}
                    <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center flex-shrink-0 border border-gray-100">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/12740/12740855.png"
                        className="w-5 h-5"
                        alt="tx"
                      />
                    </div>

                    {/* Info */}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-gray-800">รายการคำขอถอนเงิน</p>
                      {data.reason && (
                        <p className="text-xs text-gray-400 mt-0.5 truncate">หมายเหตุ: {data.reason}</p>
                      )}
                      <p className="text-xs text-gray-400 mt-0.5">
                        {formatDate(data.date)} · {formatTime(data.date)}
                      </p>
                    </div>

                    {/* Amount + status */}
                    <div className="text-right flex-shrink-0">
                      <p className={`text-sm font-bold ${data.status === "approved" ? "text-emerald-600" : "text-blue-600"}`}>
                        {formatPrice(data.amount)} ฿
                      </p>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                        data.status === "approved"
                          ? "bg-emerald-50 text-emerald-600"
                          : "bg-amber-50 text-amber-600"
                      }`}>
                        {data.status === "approved" ? "อนุมัติแล้ว" : "รอดำเนินการ"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </motion.div>

      </div>
    </div>
  );
};

export default HistoryCommission;
